import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { cloneDeep } from 'lodash'
import { computed, ref, watch } from 'vue'

interface PropsType {
  filterProps: any[]
  filterValues: any[]
  filterVisibel: boolean
  searchVal: string
  filterProp: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-plank-filter',
  props: {
    filterProps: null,
    filterValues: null,
    filterVisibel: { type: Boolean },
    searchVal: null,
    filterProp: null
  },
  emits: ["onConfirmFilter", "onCancel", "onRestFilter", "onAfterClose"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onConfirmFilter', filterValues: string[], prop: string): void
  (e: 'onCancel', payload?: boolean): void
  (e: 'onRestFilter'): void
  (e: 'onAfterClose'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  filterProps: any[]
  filterValues: any[]
  filterVisibel: boolean
  searchVal: string
  filterProp: string
}



// const emits = defineEmits([
//   'onConfirmFilter',
//   'onCancel',
//   'onRestFilter',
//   'onAfterClose',
// ])


const isShow = ref(props.filterVisibel)
const isCheckAll = ref<boolean>(true)
const filterList = ref<any[]>(props.filterValues)
const search = ref(props.searchVal)

// 特殊属性名的值对应的label
const propNameMap: Record<string, any> = {
  texDir: {
    normal: 'common.normal',
    reverse: 'common.reverse',
    notcare: 'common.notCare',
  },
  type: {
    SingleDoor: 'common.isDoorPlank',
    Plank: 'common.notDoorPlank',
  },
  specialShape: {
    true: 'common.isSpecial',
    false: 'common.notSpecial',
  },
  is_high_gloss_plank: {
    true: 'common.heighGlossPlank',
    false: 'common.notHeighGloss',
  },
  hsInfo: {
    hasHsInfo: '有孔槽',
    noHsInfo: '无孔槽',
  },
}

const filterOptions = computed(() => {
  const filterProps = cloneDeep(props.filterProps)
  const options = filterProps
    .filter((item: string) =>
      search.value || search.value == '0'
        ? String(translateProp(item, props.filterProp))?.includes(search.value)
        : true
    )
    .map((item: string) => ({
      label: translateProp(item, props.filterProp),
      value: item,
    }))
  return options
})

// 需转换为中文的字段
function translateProp(item: any, propName: string) {
  if (propName === 'textureGrainInfo' && item === '') {
    return '无对纹组'
  }
  // 孔槽数量筛选：固定文案，不做 i18n key 转换
  if (propName === 'hsInfo' && propNameMap.hsInfo[item]) {
    return propNameMap.hsInfo[item]
  }
  let result
  if (propNameMap[propName]) {
    result = translateLang(propNameMap[propName][item])
  } else {
    result = item
  }
  return result
}

function handleSelectAll() {
  isCheckAll.value = !isCheckAll.value
  if (isCheckAll.value) {
    filterList.value = filterOptions.value.map((option) => option.value)
  } else {
    filterList.value = []
  }
}

function translateLang(key?: string) {
  return key ? translate(key) : ''
}

// 确认
function handleConfirm() {
  if (isCheckAll.value) {
    filterList.value = filterOptions.value.map((option) => option.value)
  }
  // emits('onConfirmFilter', filterList.value, search.value)
  emits('onConfirmFilter', filterList.value, props.filterProp)
}

// 取消
function handleCancel() {
  emits('onCancel')
}

// 重置筛选
function handleReset() {
  search.value = ''
  isCheckAll.value = true
  emits('onRestFilter')
}

// 弹窗关闭
function afterModalClose() {
  search.value = ''
  emits('onAfterClose')
}

watch(
  () => filterList.value,
  (val) => {
    isCheckAll.value = val.length >= filterOptions.value.length
  },
  {
    immediate: true,
  }
)

watch(
  () => props.filterVisibel,
  (val) => {
    isShow.value = val
  }
)
watch(
  () => isShow.value,
  (val) => {
    if (!val) {
      emits('onCancel', true)
    }
  }
)
watch(
  () => props.filterValues,
  (val) => {
    filterList.value = val
  },
  { immediate: true }
)

watch(
  () => props.searchVal,
  (val) => {
    search.value = val
  },
  {
    immediate: true,
  }
)

return { __sfc: true,props, emits, isShow, isCheckAll, filterList, search, propNameMap, filterOptions, translateProp, handleSelectAll, translateLang, handleConfirm, handleCancel, handleReset, afterModalClose }
}

})